import {
  BenefitStatus,
  CreateBenefitRequest,
  UpdateBenefitRequest,
} from '@aslanpay/portal-common-lib';
import { AddEditBenefitFormFields } from 'app/components/Benefits/AddEditBenefitForm';
import { isEmptyUrl } from 'app/utils/url';

const buildBenefitPayload = (
  data: AddEditBenefitFormFields,
  status: BenefitStatus
): UpdateBenefitRequest | CreateBenefitRequest =>
  ({
    name: data.benefitName,
    status,
    description: data.description?.trim() ? data.description : null,
    shortDescription: data.shortDescription?.trim() ? data.shortDescription : null,
    linkUrl: isEmptyUrl(data.employeeLink) ? null : data.employeeLink,
    // only include linkName if employeeLink is provided
    linkName: !isEmptyUrl(data.employeeLink) && data.linkName?.trim() ? data.linkName : null,
    logoUrl: data.logoUrl?.trim() ? data.logoUrl : null,
    categoryIds: data.categoryIds,
    highlights: data.highlights
      ?.filter((h) => h.text?.trim())
      .map((h, index) => ({ text: h.text, displayOrder: index })),
    images: data.images
      ?.filter((img) => img.imageUrl?.trim())
      .map((img, index) => ({ imageUrl: img.imageUrl, displayOrder: index })),
    videoUrls: data.videoUrls
      ?.filter((v) => v.url?.trim() && v.url.trim() !== 'https://')
      .map((v, index) => ({ url: v.url, displayOrder: index })),
    faqs: data.faqs
      ?.filter((f) => f.question?.trim() && f.answer?.trim())
      .map((f, index) => ({ question: f.question, answer: f.answer, displayOrder: index })),
    links: (data.links ?? [])
      .filter((l) => !isEmptyUrl(l.linkUrl) && l.linkName?.trim())
      .map((l, index) => ({ linkUrl: l.linkUrl, linkName: l.linkName, displayOrder: index })),
    documents: (data.documents ?? [])
      .filter((d) => d.fileUploadId && d.displayName?.trim())
      .map((d, index) => ({
        ...(d.id && { id: d.id }),
        fileUploadId: d.fileUploadId,
        displayName: d.displayName.trim(),
        displayOrder: index,
      })),
    eligibilityCriteria: (data.eligibilityCriteria ?? [])
      .filter((c) => c.text?.trim())
      .map((c, index) => ({ text: c.text, displayOrder: index })),
  } as UpdateBenefitRequest | CreateBenefitRequest);

export default buildBenefitPayload;
